import { Injectable } from "@angular/core";
import { DocumentoObra } from "../models/entities/documento-obra";
import { AngularFireDatabase } from "@angular/fire/database";
import { Observable } from "rxjs";
import { database } from "firebase";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class DocumentoObraService {
  public path: string;

  constructor(public angularFireDatabase: AngularFireDatabase) {
    this.path = "documentosObras";
  }
  public save(documentoObra: DocumentoObra): Promise<any> {
    return this.angularFireDatabase
      .list<DocumentoObra>(this.path)
      .push(documentoObra);
  }

  public update(
    keyDocumentoObra: string,
    documentoObra: DocumentoObra
  ): Promise<any> {
    return this.angularFireDatabase
      .list<DocumentoObra>(this.path)
      .update(keyDocumentoObra, documentoObra);
  }

  public delete(keyDocumentoObra: string): Promise<any> {
    return this.angularFireDatabase
      .list<DocumentoObra>(this.path)
      .remove(keyDocumentoObra);
  }

  public findByKeyObra(keyObra: string): Observable<DocumentoObra[]> {
    return this.angularFireDatabase
      .list<DocumentoObra>(this.path, (ref: database.Reference) =>
        ref.orderByChild("keyObra").equalTo(keyObra)
      )
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as DocumentoObra)
          )
        )
      );
  }

  public findAll(): Observable<DocumentoObra[]> {
    return this.angularFireDatabase
      .list<DocumentoObra>(this.path)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as DocumentoObra)
          )
        )
      );
  }
}
